export const colors = {
  primary: {
    50: '#eff4ff',
    100: '#dbeafe',
    200: '#bfdbfe',
    300: '#93c5fd',
    400: '#60a5fa',
    500: '#3971ff', // rhBlue as main primary
    600: '#2563eb',
    700: '#1d4ed8',
    800: '#1e40af',
    900: '#1e3a8a',
    950: '#172554',
  },
  // Add other color scales as needed
  gray: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
    950: '#030712',
  },
  rhBlue: {
    50: '#eff4ff',
    100: '#dbeafe',
    200: '#bfdbfe',
    300: '#93c5fd',
    400: '#60a5fa',
    500: '#3971ff', // Main rhBlue color
    600: '#2563eb',
    700: '#1d4ed8',
    800: '#1e40af',
    900: '#1e3a8a',
    950: '#172554',
  },
  orcid: {
    50: '#F5FAEB', // Pale lemon background
    100: '#E3F3C1', // Light green
    200: '#DCEEC4', // Border green
    500: '#A6CE39', // ORCID brand green
    600: '#82A629', // Darker green for hover
  },
};
